import { render, staticRenderFns } from "./MoleculeTextarea.vue?vue&type=template&id=55acceb8&scoped=true&"
import script from "./MoleculeTextarea.vue?vue&type=script&lang=js&"
export * from "./MoleculeTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeTextarea.vue?vue&type=style&index=0&id=55acceb8&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acceb8",
  null
  
)

export default component.exports